import React, { useState, useEffect } from 'react';
import UploadTemplate from './uploadTemplate';
import korrectLogo from '../../assets/images/korrectLogoIcon.png';
import dataLoaderServices from './DataLoaderServices';

export default function DataLoader(subEntity: any) {

    let [fugaStatus, setFugaStatus] = useState(false);
    let [activeMenu, setActiveMenu] = useState("Contacts");
    let [activeSubTab, setactiveSubTab] = useState("BasicContactDetails");

    const menu = [
        { label: 'Menu', value: 'Contacts' },
        { label: 'Menu', value: 'Contracts' },
        { label: 'Menu', value: 'Contract Links' },
    ];

    const menuMeta = [
        { label: 'Menu', value: 'Release/Track' },
        { label: 'Menu', value: 'CWR' },
        { label: 'Menu', value: 'CUE' },
        { label: 'Menu', value: 'Minimum Set Uploader' },
        { label: 'Menu', value: 'Song' },
    ];

    const menuAccounting = [
        { label: 'Menu', value: 'Upload Mechanicals' },
        { label: 'Menu', value: 'Mappings' },
        { label: 'Menu', value: 'Data Transfer' },
    ];

    const closeModal = (e: any) => {
        //setShowTab(false);
        const modal = document.getElementById("myModal") as HTMLElement;
        modal?.classList.remove("displayItem");
        modal?.classList.add("displayNoneItem");
        document.body.classList.remove("HiddenoverflowX");
    }

    const onChangeMenu = (e: any) => {
        console.log(e)
        setActiveMenu(e)

        if (e == "Contacts") {
            setactiveSubTab("BasicContactDetails")
        }
        if (e == "Contracts") {
            setactiveSubTab("rateBasis")
        }
        if (e == "Mappings") {
            setactiveSubTab("mappingTerritory")
        }
        if (e == "Upload Mechanicals") {
            setactiveSubTab("mechanicalContract")
        }
        if (e == "Data Transfer") {
            setactiveSubTab("Artist Contracts")
        }
        if ((e == "Contract Links")) {
            setactiveSubTab("")
        }
        if (e == "CWR") {
            setactiveSubTab("")
        }
        if (e == "CUE") {
            setactiveSubTab("")
        }

        if (e == "Song") {
            setactiveSubTab("")
        }

        if (e == "Minimum Set Uploader") {
            setactiveSubTab("Tracks")
        }

        if (e == "Release/Track") {
            setactiveSubTab("releaseTrack")
            dataLoaderServices.fugaStatus().then((value: any) => { setFugaStatus(value) })
        }
    }

    return (
        <>

            {(subEntity) && <div id="myModal" className="modal pLarge ws-12 ">

                <a onClick={() => closeModal(true)} className="btn-xxs modalClose borderNone bgTransparent" style={{ position: "inherit" }} href="../../">
                    <i className="icon-close3 danger"></i>
                </a>

                <div className="allowHscroll allowVscroll full-height-vh95 ws-12 box" style={{ minHeight: "80%" }}>
                    <div className="12">
                        <div className="ws-2 pm borderReset full-height pLarge">
                            <div className="ws-12 text-center pLarge mtll mbl">
                                <img className="pull-none" src={korrectLogo} width={50} />
                            </div>

                            <ul className="main-menu pll prl ws-12">
                                <a className="full-width text-bold text-average text-m mtl ws-12 pbl">Contractual</a>
                                <ul >
                                    {menu?.map((value: any) => {
                                        return (<>
                                            {<li key={value.title} className={activeMenu === value.value ? " active" : ""}>
                                                <a className={"ws-12 text-sl text-normal"} onClick={() => { onChangeMenu(value.value) }}> {value.value} </a>
                                            </li>}
                                        </>)
                                    })}
                                </ul>
                            </ul>

                            <ul className="main-menu pll prl ws-12">
                                <a className="full-width text-bold text-average text-m mtl ws-12 pbl">Metadata</a>
                                <ul >
                                    {menuMeta?.map((value: any) => {
                                        return (<>
                                            {<li key={value.title} className={activeMenu === value.value ? " active" : ""}>
                                                <a className={"ws-12 text-sl text-normal"} onClick={() => { onChangeMenu(value.value) }}> {value.value} </a>
                                            </li>}
                                        </>)
                                    })}
                                </ul>
                            </ul>

                            <ul className="main-menu pll prl ws-12">
                                <a className="full-width text-bold text-average text-m mtl ws-12 pbl">Accounting</a>
                                <ul >
                                    {menuAccounting?.map((value: any) => {
                                        return (<>
                                            {<li key={value.title} className={activeMenu === value.value ? " active" : ""}>
                                                <a className={"ws-12 text-sl text-normal"} onClick={() => { onChangeMenu(value.value) }}> {value.value} </a>
                                            </li>}
                                        </>)
                                    })}
                                </ul>
                            </ul>
                        </div>

                        <div className="ws-10 pm landing">

                            <div className="ws-12 ptxl mtl">
                                <span className="ws-12 text-bold text-xl">DataLoader</span>
                                <span className="ws-12 ptl text-bold text-m turquoise">{activeMenu}</span>
                            </div>
                            {

                                <div className='ws-12 mtl'>
                                    {(activeMenu === "Minimum Set Uploader") && <a onClick={() => { setactiveSubTab("Tracks"); }} className={activeSubTab === "Tracks" ? "btn-success active" : "btn-success"}>Tracks</a>}
                                    {(activeMenu === "Minimum Set Uploader") && <a onClick={() => { setactiveSubTab("Releases"); }} className={activeSubTab === "Releases" ? "btn-success active" : "btn-success"}>Releases</a>}
                                    {(activeMenu === "Minimum Set Uploader") && <a onClick={() => { setactiveSubTab("Dealerprice"); }} className={activeSubTab === "Dealerprice" ? "btn-success active" : "btn-success"}>Dealer price</a>}
                                    {(activeMenu === "Minimum Set Uploader") && <a onClick={() => { setactiveSubTab("releaseTrack"); }} className={activeSubTab === "releaseTrack" ? "btn-success active" : "btn-success"}>Release Track</a>}
                                    {(activeMenu === "Minimum Set Uploader") && <a onClick={() => { setactiveSubTab("Songs"); }} className={activeSubTab === "Songs" ? "btn-success active" : "btn-success"}>Songs</a>}

                                    {(activeMenu === "Release/Track") && <a onClick={() => { setactiveSubTab("releaseTrack"); }} className={activeSubTab === "releaseTrack" ? "btn-success active" : "btn-success"}>Release Track</a>}
                                    {(activeMenu === "Release/Track") && <a onClick={() => { setactiveSubTab("Releases"); }} className={activeSubTab === "Releases" ? "btn-success active" : "btn-success"}>Releases</a>}
                                    {(activeMenu === "Release/Track") && <a onClick={() => { setactiveSubTab("Track"); }} className={activeSubTab === "Track" ? "btn-success active" : "btn-success"}>Track</a>}
                                    {(activeMenu === "Release/Track" && fugaStatus) && <a onClick={() => { setactiveSubTab("Distributor"); }} className={activeSubTab === "Distributor" ? "btn-success active" : "btn-success"}>Distributor</a>}


                                    {(activeMenu === "Contacts") && <a onClick={() => { setactiveSubTab("BasicContactDetails"); }} className={activeSubTab === "BasicContactDetails" ? "btn-success active" : "btn-success"}> Basic Contact Details </a>}
                                    {(activeMenu === "Contacts") && <a onClick={() => { setactiveSubTab("AdditionalContactRecipients"); }} className={activeSubTab === "AdditionalContactRecipients" ? "btn-success active" : "btn-success"}>Contact Additional recipients</a>}
                                    {(activeMenu === "Contacts") && <a onClick={() => { setactiveSubTab("ContactStatuses"); }} className={activeSubTab === "ContactStatuses" ? "btn-success active" : "btn-success"}>Contact Statuses</a>}


                                    {(activeMenu === "Contracts") && <a onClick={() => { setactiveSubTab("rateBasis"); }} className={activeSubTab === "rateBasis" ? "btn-success active" : "btn-success"}>Rates/Basis</a>}
                                    {(activeMenu === "Contracts") && <a onClick={() => { setactiveSubTab("regions"); }} className={activeSubTab === "regions" ? "btn-success active" : "btn-success"}>Regions</a>}
                                    {(activeMenu === "Contracts") && <a onClick={() => { setactiveSubTab("adjustments"); }} className={activeSubTab === "adjustments" ? "btn-success active" : "btn-success"}>Adjustments</a>}
                                    {(activeMenu === "Contracts") && <a onClick={() => { setactiveSubTab("reserves"); }} className={activeSubTab === "reserves" ? "btn-success active" : "btn-success"}>Reserves</a>}
                                    {(activeMenu === "Contracts") && <a onClick={() => { setactiveSubTab("reducingRoyalties"); }} className={activeSubTab === "reducingRoyalties" ? "btn-success active" : "btn-success"}>Reducing Royalties</a>}
                                    {(activeMenu === "Contracts") && <a onClick={() => { setactiveSubTab("contractStatus"); }} className={activeSubTab === "contractStatus" ? "btn-success active" : "btn-success"}>Contract Statuses</a>}
                                    {(activeMenu === "Contracts") && <a onClick={() => { setactiveSubTab("contractGrouping"); }} className={activeSubTab === "contractGrouping" ? "btn-success active" : "btn-success"}>Contract Grouping</a>}


                                    {(activeMenu === "Upload Mechanicals") && <a onClick={() => { setactiveSubTab("mechanicalContract"); }} className={activeSubTab === "mechanicalContract" ? "btn-success active" : "btn-success"}>Contracts</a>}
                                    {(activeMenu === "Upload Mechanicals") && <a onClick={() => { setactiveSubTab("mechanicalTrackSplits"); }} className={activeSubTab === "mechanicalTrackSplits" ? "btn-success active" : "btn-success"}>Track Splits</a>}
                                    {(activeMenu === "Upload Mechanicals") && <a onClick={() => { setactiveSubTab("mechanicalLicenses"); }} className={activeSubTab === "mechanicalLicenses" ? "btn-success active" : "btn-success"}>Licenses</a>}

                                    {(activeMenu === "Mappings") && <a onClick={() => { setactiveSubTab("mappingTerritory"); }} className={activeSubTab === "mappingTerritory" ? "btn-success active" : "btn-success"}>Territories</a>}
                                    {(activeMenu === "Mappings") && <a onClick={() => { setactiveSubTab("mappingFormat"); }} className={activeSubTab === "mappingFormat" ? "btn-success active" : "btn-success"}>Formats/Source Codes </a>}
                                    {(activeMenu === "Mappings") && <a onClick={() => { setactiveSubTab("mappingCatalogue"); }} className={activeSubTab === "mappingCatalogue" ? "btn-success active" : "btn-success"}>Catalogs</a>}
                                    {(activeMenu === "Mappings") && <a onClick={() => { setactiveSubTab("mappingRaw"); }} className={activeSubTab === "mappingRaw" ? "btn-success active" : "btn-success"}>Raw</a>}
                                    {(activeMenu === "Mappings") && <a onClick={() => { setactiveSubTab("mappingAudit"); }} className={activeSubTab === "mappingAudit" ? "btn-success active" : "btn-success"}>Audit </a>}
                                    {(activeMenu === "Mappings") && <a onClick={() => { setactiveSubTab("mappingRawPub"); }} className={activeSubTab === "mappingRawPub" ? "btn-success active" : "btn-success"}>Raw Pub</a>}
                                    {(activeMenu === "Mappings") && <a onClick={() => { setactiveSubTab("mappingAuditPub"); }} className={activeSubTab === "mappingAuditPub" ? "btn-success active" : "btn-success"}>Audit Pub</a>}
                                    {(activeMenu === "Mappings") && <a onClick={() => { setactiveSubTab("mappingAnalysisCode"); }} className={activeSubTab === "mappingAnalysisCode" ? "btn-success active" : "btn-success"}>Analysis Codes </a>}
                                    {(activeMenu === "Mappings") && <a onClick={() => { setactiveSubTab("mappingClassList.excel"); }} className={activeSubTab === "mappingClassList.excel" ? "btn-success active" : "btn-success"}>Class List</a>}
                                    {(activeMenu === "Mappings") && <a onClick={() => { setactiveSubTab("mappingInvoice"); }} className={activeSubTab === "mappingInvoice" ? "btn-success active" : "btn-success"}>Invoice</a>}
                                    {(activeMenu === "Mappings") && <a onClick={() => { setactiveSubTab("mappingSong"); }} className={activeSubTab === "mappingSong" ? "btn-success active" : "btn-success"}>Songs</a>}

                                    {(activeMenu === "Data Transfer") && <a onClick={() => { setactiveSubTab("Artist Contracts"); }} className={activeSubTab === "Artist Contracts" ? "btn-success active" : "btn-success"}>Artist Contracts</a>}
                                    {(activeMenu === "Data Transfer") && <a onClick={() => { setactiveSubTab("Artist Payees"); }} className={activeSubTab === "Artist Payees" ? "btn-success active" : "btn-success"}>Artist Payees</a>}
                                    {(activeMenu === "Data Transfer") && <a onClick={() => { setactiveSubTab("Transactions License"); }} className={activeSubTab === "Transactions License" ? "btn-success active" : "btn-success"}>Transactions License</a>}
                                    {(activeMenu === "Data Transfer") && <a onClick={() => { setactiveSubTab("Transactions Publisher"); }} className={activeSubTab === "Transactions Publisher" ? "btn-success active" : "btn-success"}>Transactions Publisher</a>}

                                </div>}
                            {
                                (() => {

                                    if (activeMenu !== "Bulk Update") {
                                        return (
                                            <div className='pl'> <UploadTemplate type={activeMenu} subType={activeSubTab} /> </div>

                                        )
                                    }

                                })()
                            }
                        </div>

                    </div>
                </div>

            </div>}
        </>
    )
}